"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSearchClickSelector = exports.fromRecomDetailSelector = exports.fromRecomClickSelector = exports.fromBeforeSelector = void 0;
const fromParser_1 = require("./fromParser");
const fromBeforeSelector = (from, payload, test) => {
    // 이전에 보낸 로그
    (0, fromParser_1.fromBeforeParser)(payload);
    localStorage.setItem("dclogformer", JSON.stringify(payload.Data));
    switch (from) {
        case "recom": {
            if (!test) {
                localStorage.setItem("from_recom_log", JSON.stringify(payload.Data));
            }
            break;
        }
        case "search": {
            break;
        }
        case "list": {
            break;
        }
        case "listmap": {
            break;
        }
        default: {
            break;
        }
    }
};
exports.fromBeforeSelector = fromBeforeSelector;
const fromRecomClickSelector = (from, payload) => {
    switch (from) {
        case "recom": {
            (0, fromParser_1.fromRecomParser)(payload);
            break;
        }
        case "recom_detail": {
            (0, fromParser_1.fromRecomDetailParser)(payload);
            break;
        }
        case "search": {
            (0, fromParser_1.fromSearchParser)(payload);
            break;
        }
        default: {
            break;
        }
    }
};
exports.fromRecomClickSelector = fromRecomClickSelector;
const fromRecomDetailSelector = (from, payload) => {
    switch (from) {
        case "recom": {
            (0, fromParser_1.fromRecomParser)(payload);
            localStorage.setItem("from_recom_detail_log", JSON.stringify(payload.Data));
            break;
        }
        case "search": {
            (0, fromParser_1.fromSearchParser)(payload);
            localStorage.setItem("from_recom_detail_log", JSON.stringify(payload.Data));
            break;
        }
        default: {
            break;
        }
    }
};
exports.fromRecomDetailSelector = fromRecomDetailSelector;
const fromSearchClickSelector = (payload) => {
    (0, fromParser_1.fromSearchClickParser)(payload);
};
exports.fromSearchClickSelector = fromSearchClickSelector;
